import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { setMessage } from "./message";
import { setLoading } from "./loading";
import OshmaService from "../services/oshma.service";

const initialState = {
  oshma: [],
  totalElements: 0,
  totalPages: 0,
  size: 10,
  page: 0,
  searchValue: "",
  currentPage: 0,
  searchValueCurrent: "",
  oshmaById: {},
};

export const setSearch = createAsyncThunk(
  "users/setSearchValue",
  ({ searchValue }, thunkAPI) => {
    return {
      searchValue: searchValue,
    };
  }
);
export const getAllOshmas = createAsyncThunk(
  "oshma/getAllOshmas",
  async ({ page, searchValue, size, filterSelect = false }, thunkAPI) => {
    try {
      const data = await OshmaService.getAllOshmas(
        page,
        searchValue,
        size,
        filterSelect
      );
      return {
        oshma: data.content,
        totalElements: data.totalElements,
        totalPages: data.totalPages,
        size: data.size,
        currentPage: data.number,
        searchValueCurrent: searchValue,
      };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      // thunkAPI.dispatch(setMessage(message));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const createOshma = createAsyncThunk(
  "oshma/create",
  async ({ oshma }, thunkAPI) => {
    thunkAPI.dispatch(setLoading(true));
    try {
      const data = await OshmaService.createOshma(oshma);
      thunkAPI.dispatch(getAllOshmas({ page: 0, searchValue: "" }));
      thunkAPI.dispatch(setLoading(false));
      return thunkAPI.rejectWithValue();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setLoading(false));
      thunkAPI.dispatch(setMessage({ message: message }));
      thunkAPI.dispatch(getAllOshmas({ page: 0, searchValue: "" }));
      return thunkAPI.rejectWithValue();
    }
  }
);
export const updateOshma = createAsyncThunk(
  "oshma/update",
  async ({ oshma, currentPage, searchValueCurrent }, thunkAPI) => {
    thunkAPI.dispatch(setLoading(true));
    try {
      const data = await OshmaService.updateOshma(oshma);
      thunkAPI.dispatch(
        getAllOshmas({
          page: currentPage ? currentPage : 0,
          searchValue: searchValueCurrent ? searchValueCurrent : "",
        })
      );
      // thunkAPI.dispatch(getAllUnit({ page: 0, searchValue: "" }));
      thunkAPI.dispatch(setLoading(false));
      return thunkAPI.rejectWithValue();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setLoading(false));
      thunkAPI.dispatch(setMessage({ message: message }));
      thunkAPI.dispatch(getAllOshmas({ page: 0, searchValue: "" }));
      return thunkAPI.rejectWithValue();
    }
  }
);

export const deleteOshma = createAsyncThunk(
  "oshma/delete",
  async ({ id, currentPage = 0, searchValueCurrent = "" }, thunkAPI) => {
    try {
      const data = await OshmaService.deleteOshma(id);
      thunkAPI.dispatch(setMessage({ message: "Rekordi u fshi me sukses!" }));
      thunkAPI.dispatch(
        getAllOshmas({
          page: currentPage ? currentPage : 0,
          searchValue: searchValueCurrent ? searchValueCurrent : "",
        })
      );
      return thunkAPI.rejectWithValue();
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      thunkAPI.dispatch(setMessage({ message: message }));
      thunkAPI.dispatch(
        getAllOshmas({
          page: currentPage ? currentPage : 0,
          searchValue: searchValueCurrent ? searchValueCurrent : "",
        })
      );
      return thunkAPI.rejectWithValue();
    }
  }
);

export const getOshmaById = createAsyncThunk(
  "oshma/getOshmaById",
  async ({ id }, thunkAPI) => {
    thunkAPI.dispatch(setLoading(true));
    try {
      const data = await OshmaService.getOshmaById(id);
      thunkAPI.dispatch(setLoading(false));
      return { oshmaById: data };
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      // thunkAPI.dispatch(setMessage(message));
      thunkAPI.dispatch(setLoading(false));
      return thunkAPI.rejectWithValue();
    }
  }
);

const oshmaSlice = createSlice({
  name: "oshma",
  initialState,
  extraReducers: {
    [getAllOshmas.fulfilled]: (state, action) => {
      state.oshma = action.payload.oshma;
      state.totalElements = action.payload.totalElements;
      state.totalPages = action.payload.totalPages;
      state.size = action.payload.size;
      state.searchValue = action.payload.searchValue;
      state.currentPage = action.payload.currentPage;
      state.searchValueCurrent = action.payload.searchValueCurrent;
    },
    [getAllOshmas.rejected]: (state, action) => {
      state.oshma = null;
      state.totalElements = 0;
      state.totalPages = 0;
      state.size = 10;
      state.searchValue = "";
    },
    [setSearch.fulfilled]: (state, action) => {
      state.searchValue = action.payload.searchValue;
    },
    [setSearch.rejected]: (state, action) => {
      state.searchValue = "";
    },
    [getOshmaById.fulfilled]: (state, action) => {
      state.oshmaById = action.payload.oshmaById;
    },
    [getOshmaById.rejected]: (state, action) => {
      state.oshmaById = {};
    },
  },
});

const { reducer } = oshmaSlice;
export default reducer;
